/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Restore_FailedInputs */

const en_plan_restore_failed = /** @type {(inputs: Plan_Restore_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restore failed`)
};

const es_plan_restore_failed = /** @type {(inputs: Plan_Restore_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al restaurar`)
};

/**
* | output |
* | --- |
* | "Restore failed" |
*
* @param {Plan_Restore_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_restore_failed = /** @type {((inputs?: Plan_Restore_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Restore_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_restore_failed(inputs)
	return en_plan_restore_failed(inputs)
});